<template>
  <section class="card">
    <h2 class="section-heading">
      {{ t('employerForm.insuranceCalculation.title') }}
    </h2>

    <div class="form-grid">
      <div class="form_group">
        <label>
          {{ t('employerForm.insuranceCalculation.dailyCost') }}
        </label>

        <input
          type="number"
          step="0.01"
          :value="dailyCost"
          class="bg-light"
          :placeholder="t('employerForm.insuranceCalculation.dailyCost')"
          readonly
        />
      </div>

      <div class="form_group">
        <label>
          {{ t('employerForm.insuranceCalculation.insuredDays') }}
        </label>

        <input
          type="number"
          :value="insuredDays"
          class="bg-light"
          :placeholder="t('employerForm.insuranceCalculation.insuredDays')"
          readonly
        />
      </div>

      <div class="form_group">
        <label>
          {{ t('employerForm.insuranceCalculation.totalPremium') }}
        </label>

        <input
          type="number"
          step="0.01"
          class="bg-light"
          :value="totalPremium"
          :placeholder="t('employerForm.insuranceCalculation.totalPremium')"
          readonly
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({})
  },
  provider: {
    type: String,
    default: null
  },
  insurnacePeriod: {
    type: Object,
    default: () => ({})
  },
  settings:{
    type:Object,
    default: () => ({
      daily_cost_clalit:9.11,
      daily_cost_meuhedet:8.3
    })
  }
});

const emit = defineEmits([
  'update:modelValue',
]);

const dailyCost = computed(() => {
  if (!props.provider)  return 0;
  return props.provider === 'clalit' ? props.settings.daily_cost_clalit : props.settings.daily_cost_meuhedet;
});
const insuredDays = computed(() => {

  const from = props.insurnacePeriod?.from;
  const to = props.insurnacePeriod?.to;

  if (!from || !to) return 0;

  const start = new Date(from);
  const end = new Date(to);

  return Math.ceil(
    (end - start) / (1000 * 60 * 60 * 24)
  ) + 1;
});
const totalPremium = computed(() => {
  return (dailyCost.value * insuredDays.value).toFixed(2);
});
watch(
  [dailyCost, insuredDays, totalPremium],
  () => emit('update:modelValue', {
      dailyCost: dailyCost.value,
      insuredDays: insuredDays.value,
      totalPremium: totalPremium.value,
    }),
  { deep: true }
);
</script>